export const parseComponentTypes = (tags, type) => {
    const output = new Set();
    if (tags.includes("type:cta")) {
        output.add("ONSITE");
    }
    if (tags.includes("type:business-event")) {
        output.add("BUSINESS_EVENT");
    }
    if (tags.includes("type:email")) {
        output.add("EMAIL");
    }
    if (tags.includes("type:integration")) {
        output.add("INTEGRATION");
    }
    if (tags.includes("type:rule")) {
        output.add("RULE");
    }
    if (tags.some((tag) => tag.startsWith("promotion-type:"))) {
        output.add("PROMOTION");
    }
    if (tags.includes("promotion-type:onsite")) {
        output.add("ONSITE");
    }
    if (tags.includes("promotion-type:email")) {
        output.add("EMAIL");
    }
    const isJourneyType = tags.includes("type:journey") ||
        (type !== null && /^journey(-v[0-9]+)?$/.test(type));
    if (isJourneyType) {
        output.add("JOURNEY");
    }
    if (tags.includes("internal:type:extension") ||
        (type !== null && /^extension(-v[0-9]+)?$/.test(type))) {
        output.add("EXTENSION");
    }
    return Array.from(output);
};
